import PurchaseContent from 'components/IndividualAppPurchaseModal/IndividualAppPurchaseModal';

export const modalRegistrator = {
    inAppPurchaseModal: PurchaseContent,
};
